import { render } from "./OcrSkBlock.vue?vue&type=template&id=7c4b2954"
import script from "./OcrSkBlock.vue?vue&type=script&lang=js"
export * from "./OcrSkBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__